var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUidesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.589,
    height: 51.874,
    viewBox: "0 0 74.589 51.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.9 -18.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.482,33.126a7.293,7.293,0,0,0,7.123-6.556H33.686v1.143A22.334,22.334,0,0,0,18.841,48.783v5.891H12.593v15.04h15.04V54.674H20.461V48.766A20.713,20.713,0,0,1,33.686,29.447V33.28h15.04V29.439A20.664,20.664,0,0,1,61.952,48.766v5.908h-7.18v15.04H69.82V54.674H63.573V48.766A22.277,22.277,0,0,0,48.727,27.7V26.571H63.613a7.374,7.374,0,0,0,14.676-.81,7.374,7.374,0,0,0-14.676-.81H48.727V18.24H33.686v6.71H18.606a7.293,7.293,0,0,0-7.139-6.556,7.366,7.366,0,1,0,0,14.732Zm14.53,34.967h-11.8v-11.8h11.8Zm42.179,0h-11.8v-11.8H68.2ZM70.923,20.2a5.567,5.567,0,1,1-5.745,5.567A5.673,5.673,0,0,1,70.923,20.2Zm-35.656-.34H47.106v11.8h-11.8Zm-23.817.154A5.745,5.745,0,1,1,5.7,25.76a5.745,5.745,0,0,1,5.745-5.745Z",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUidesign);
export default __webpack_public_path__ + "static/media/uidesign.454e5e55.svg";
export { ForwardRef as ReactComponent };